import { useState } from "react";
import { api } from "../api";
import { IconSparkle } from "./icons";
import { Spinner } from "./ui";

export function Login({ onSuccess }: { onSuccess: () => void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.login(password);
      onSuccess();
    } catch (err) {
      setError(err instanceof Error ? err.message : "ログインに失敗しました");
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-dvh place-items-center bg-gradient-to-b from-brand-50 to-slate-50 px-4">
      <form onSubmit={submit} className="card w-full max-w-sm p-7">
        <div className="mb-5 flex items-center gap-2.5">
          <span className="grid h-9 w-9 place-items-center rounded-xl bg-brand-500 text-white">
            <IconSparkle className="h-5 w-5" />
          </span>
          <div>
            <h1 className="text-[17px] font-bold text-slate-800">Image Forge</h1>
            <p className="text-[12.5px] text-slate-400">社内向け 画像一括生成ツール</p>
          </div>
        </div>

        <label className="mb-1.5 block text-[13px] font-semibold text-slate-500">共有パスワード</label>
        <input
          type="password"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="field"
          placeholder="社内で共有されているパスワード"
        />
        {error && <p className="mt-2 text-[13px] font-medium text-rose-600">{error}</p>}

        <button type="submit" disabled={busy || !password} className="btn-primary mt-4 w-full py-2.5">
          {busy ? <Spinner /> : null}
          ログイン
        </button>
      </form>
    </div>
  );
}
